import CreateCustomerScreen from '@screens/staff/createCustomer/CreateCustomerScreen'

export default CreateCustomerScreen
